import { 
  RouterProvider,
  createBrowserRouter,
  redirect
} from 'react-router-dom'
import Login from './pages/login'
import Home from './pages/home'
import MpChat from './pages/mpChat'
import NotFound from './pages/404'

const interceptToken = () => {
  const token = localStorage.getItem('token')
  if (token) {
    throw redirect('/home')
  }
  return null
}

const interceptNoToken = () => {
  const token = localStorage.getItem('token')
  if (!token) {
    throw redirect('/404')
  }
  return null
}

const router = createBrowserRouter([
  {
    path: '/login/:schoolOid',
    element: <Login />,
    loader: () => interceptToken()
  },
  {
    path: '/home',
    element: <Home />,
    loader: () => interceptNoToken()
  },
  {
    path: '/mpchat/:contactId',
    element: <MpChat />
  },
  {
    path: '/*',
    element: <NotFound />
  }
])

export default function Router() {
  return (
    <RouterProvider router={router} />
  )
}
